import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import router from "@/router";
  import LocalStorageService from "@/services/localStorage.service";
  import { useStore } from "vuex";
  import { POSITION, useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationVerifyView',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();

  const toast = useToast();
  const email = ref<string | null>("");
  const showError = ref(false);

  onMounted(() => {
    init();
  });

  function init() {
    const { userEmail } = router.currentRoute.value.params;

    if (userEmail) {
      LocalStorageService.set("verifyEmail", String(userEmail));
      email.value = String(userEmail);
    } else {
      if (LocalStorageService.get("verifyEmail")) {
        email.value = LocalStorageService.get("verifyEmail");
      } else {
        showError.value = true;
      }
    }
  }
  const onResend = () => {
    store
      .dispatch("user/retryVerify", {
        email: LocalStorageService.get("verifyEmail"),
        url: LocalStorageService.get("urlAfterVerify"),
        estateId: router.currentRoute.value.params?.estateId,
      })
      .then(() => {
        toast.success("The link was sent", {
          position: POSITION.TOP_LEFT,
          timeout: 3000,
        });
        setTimeout(() => {
          router.go(-1);
        }, 3000);
      })
      .catch(() => {
        toast.error("Something went wrong", {
          position: POSITION.TOP_LEFT,
          timeout: 3000,
        });
        setTimeout(() => {
          router.go(-1);
        }, 3000);
      });
  };

const __returned__ = { store, toast, email, showError, init, onResend, onMounted, ref, get router() { return router }, get LocalStorageService() { return LocalStorageService }, get useStore() { return useStore }, get POSITION() { return POSITION }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})